//import bootstrap from './bootstrap'; // Load plugins needed here

(function($) {

    'use strict';

    setTimeout(() => {
        console.log("ES6 FTW");
    }, 1000);

    class DenApp {
        constructor(properties) {  
            this.properties = properties;

            $('#btn-mobile-menu').on('click',function(e){
                if( $(this).hasClass('btn-active') ) { 
                    $(this).removeClass('btn-active');
                    $('.navbar-collapse').slideUp();
                    $('.mobile-logo-active').hide();
                    $('.mobile-logo-default').show();
                    $('.den-navbar').removeClass('den-menu-is-active');
                    $('.site-navbar').removeClass('menu-is-active');
                }else{
                    $(this).addClass('btn-active');
                    $('.navbar-collapse').slideDown();
                    $('.den-navbar').addClass('den-menu-is-active');
                    $('.site-navbar').addClass('menu-is-active');
                    $('.mobile-logo-default').hide();
                    $('.mobile-logo-active').show();  
                }
            });

            $('.menu-item-has-children').each(function(i){
                let _this = $(this);

                _this.on('click',function(e){
                    console.log('Lol');
                    _this.find('.sub-menu').slideToggle();
                })
            });

            if(location.pathname == "/forum/members/"){
                $('.site-container #spMainContainer .spHeadContainer .spHeadTwo').hide()
            }

            $('#js-den2x-menu-button').on('click',function(e){
                e.preventDefault();
                $('#js-den2x-menu').slideToggle();
            });
        }

        homeSlider() {
            $('.testimonials-slider').each(function(){
                $(this).cardslider({
                    swipe: true,
                    dots: true, 
                    direction: 'left',
                    nav: false,

                });
            });
        }
    }

    var den = new DenApp;
    den.homeSlider();

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/main.js